import React from "react";
import { Navigate } from "react-router-dom";

import Alt404 from '../pages/AuthenticationInner/Errors/Alt404';
import CompanyDetails from "../pages/CompanyDetails/CompanyDetails";
import Dashboard from "../pages/Dashboard";
import EvidenceView from "../pages/EvidenceView";
import AssetsList from "../pages/ManageAssets/AssetsList";
import AuditorsList from "../pages/ManageAuditors/AuditorsList";
import ManageNotifications from '../pages/ManageNotifications';
import PoliciesList from "../pages/ManagePolicy/PoliciesList";
import ManageSupport from "../pages/ManageSupport";
import ViewSupport from "../pages/ManageSupport/ViewSuport";
import UsersList from "../pages/ManageUsers/UsersList";
import Projects from "../pages/Projects";
import ProjectTask from "../pages/Projects/ProjectTask";

export const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
  { path: "/company-details", component: <CompanyDetails /> },
  { path: "/users-list", component: <UsersList /> },
  { path: "/auditors-list", component: <AuditorsList /> },
  { path: "/projects", component: <Projects /> },
  { path: "/project-task/:id", component: <ProjectTask /> },
  { path: "/policies-list", component: <PoliciesList /> },
  { path: "/evidence-view", component: <EvidenceView /> },
  { path: "/assets-list", component: <AssetsList /> },
  { path: "/notifications", component: <ManageNotifications /> },
  { path: "/notifications", component: <ManageNotifications /> },
    { path: "/support", component: <ManageSupport /> },
  { path: "/suppot-ticket/:id", component: <ViewSupport /> },
  { path: "*", component: <Navigate to="/not-found" /> },
];

export const publicRoutes = [
  { path: "/not-found", component: <Alt404 /> },
];